import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function mainPhotoBlock() {
    return axios.get(`${url}/order/main_photo_block`)
        .then(response => {
            return {
                mainPhotoBlock: response.data,
                meta: response.data.meta
            };
        });
}

function mainPhotoBlockForRetoucher(params) {
    let needleUrl = `${url}/new_order/main_photo_block`;
    if (params) {
        needleUrl += '/' + params;
    }
    return axios.get(needleUrl)
        .then(response => {
            return {
                mainPhotoBlock: response.data,
                meta: response.data.meta
            };
        });
}

function historyBlock(order_id, archive) {

    return axios.get(`${url}/new_order/chat/get/${order_id}`, {
        params: { archive }
    })
        .then(response => {
            return {
                historyBlock: response.data,
                meta: response.data.meta
            };
        });
}

function lastRetouchers(params) {
    return axios.get(`${url}/new_order/chat/lastRetouchers/` + params)
        .then(response => {
            return {
                lastRetouchers: response.data,
                meta: response.data.meta
            };
        });
}

function adminComments(params) {
    return axios.get(`${url}/new_order/chat/adminComments/` + params)
        .then(response => {
            return {
                adminComments: response.data,
                meta: response.data.meta
            };
        });
}

function prevOrdersBlock(role) {
    let needleUrl = `${url}/new_order/order_history_block`;
    if (role) {
        needleUrl += '/' + role;
    }
    return axios.get(needleUrl)
        .then(response => {
            return {
                prevOrdersBlock: response.data,
                meta: response.data.meta
            };
        });
}

function prevOrdersBlockById(order_id, archive) {
    let needleUrl = `${url}/new_order/order_history_block_by_id/` + order_id;

    return axios.get(needleUrl, {
        params: { archive }
    })
        .then(response => {
            return {
                prevOrdersBlockById: response.data,
                meta: response.data.meta
            };
        });
}

function orderFunctionsBlock(payload) {
    return axios.post(`${url}/new_order/functions/get`, payload)
        .then(response => {
            return {
                orderFunctionsBlock: response.data,
            };
        }).catch(err => {
            return {
                orderFunctionsBlock: err.response.data.message,
            };
        });
}

function orderFunctionsClientFile(payload) {
    return axios.post(`${url}/new_order/functions/get-function-client-file`, payload)
        .then(response => {
            return {
                orderFunctionsClientFile: response.data,
            };
        }).catch(err => {
            return {
                orderFunctionsClientFile: err.response.data.message,
            };
        });
}

function infoBlock() {
    return axios.get(`${url}/order/order_info_block`)
        .then(response => {
            return {
                infoBlock: response.data,
                meta: response.data.meta
            };
        });
}

async function financeBlockForRetoucher(payload) {
    return axios.post(`${url}/new_order/finances/get`, payload)
        .then(response => {
            return {
                financeBlockForRetoucher: response.data
            };
        });
}

async function downloadFromBackFile(payload) {
    return axios.post(`${url}/forced_download`, payload)
        .then(response => {
            return {
                downloadFromBackFile: response.data
            };
        });
}

function downtime() {
    return axios.get(`${url}/order/downtime`)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}
function downtimeFuncBased() {
    return axios.get(`${url}/order/downtime-func-based`)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}

function downtimeRetoucher() {
    return axios.get(`${url}/new_order/downtime`)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}
function downtimeRetoucherFuncBased() {
    return axios.get(`${url}/new_order/downtime-func-based`)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}
function downtimeRetoucherIdleTime() {
    return axios.get(`${url}/new_order/downtime-idle-time`)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}

function dailyChatVersionRetoucherRatings(params) {
    let needleUrl = `${url}/func/list-description-cached/`;
    if (params && 'user_id' in params) needleUrl = needleUrl  + params.user_id
    return axios.get(needleUrl)
        .then(response => {
            return {dailyChatVersionRetoucherRatings : response.data};
        });
}

function downtimeProRetoucher(params) {
    let education = '';
    if (params && 'education' in params) education = '/education'

    return axios.get(`${url}/new_order/pro_retoucher_downtime` + education)
        .then(response => {
            return {
                downtimeProRetoucher: response.data,
            };
        });
}

function downtimeSeniorRetoucher() {
    return axios.get(`${url}/new_order/senior_retoucher_downtime`)
        .then(response => {
            return {
                downtimeSeniorRetoucher: response.data,
            };
        });
}

function downtimeForTestRetoucher(role) {
    return axios.get(`${url}/order/downtime/` + role)
        .then(response => {
            return {
                downtimeForTestRetoucher: response.data,
                meta: response.data.meta
            };
        });
}

function downloadExample(params) {
    return axios.get(`${url}/new_order/get_func_example/` + params)
        .then(response => {
            return {
                downloadExample: response.data
            };
        });
}

function getNewOrder(params) {
    let needleUrl = `${url}/new_order/get_new_order`;
    if (params) {
        if (typeof params == 'object') {
            if (Object.keys(params).length > 0) {
                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        needleUrl += '/' + params[key];
                    }
                }
            }
        } else {
            needleUrl += '/' + params;
        }
    }
    return axios.get(needleUrl)
        .then(response => {
            return {
                getNewOrder: response.data
            };
        })
        .catch(error => {
            return {
                getNewOrder: error.response.data
            };
        });

}

function setToIdleTime(params) {
    const payload = params;

    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/idle_time/set_to_idle_time`, payload, options)
        .then(response => {
            return {
                setToIdleTime: response.data
            };
        });
}

function submitOrder(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/admin_checked`, payload, options)
        .then(response => {
            return {
                submitOrder: response.data
            };
        });
}

function submitComments(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/admin_reDone`, payload, options)
        .then(response => {
            return {
                submitComments: response.data
            };
        });
}

function submitProblem(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/problem`, payload, options)
        .then(response => {
            return {
                submitProblem: response.data
            };
        });
}

function addFunctionToOrder(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/photo/meta/function/add`, payload, options)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function deleteFunctionToOrder(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/photo/meta/function/delete`, payload, options)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function restoreFunctionToOrder(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/photo/meta/function/restore`, payload, options)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function submitFile(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/new_order/done`, payload, options)
        .then(response => {
            return {
                submitFile: response.data
            };
        });
}

function whichRetoucher(order_id) {
    return axios.get(`${url}/order/whichretoucher/` + order_id)
        .then(response => {
            return {
                whichRetoucher: response.data,
            };
        });
}

function whichRetouchersRejectedToAnotherList(order_id) {
    return axios.get(`${url}/order/whichretoucher-rejected-to-another/` + order_id)
        .then(response => {
            return {
                whichRetouchersRejectedToAnotherList: response.data,
            };
        });
}

function countNewOrders() {
    return axios.get(`${url}/new_order/available_orders`)
        .then(response => {
            return {
                countNewOrders: response.data,
            };
        });
}

function countNewOrdersPro(options) {
    let education = null;
    if (options && Object.keys(options).length > 0 && 'education' in options) education = '/null/' + options.education;
    return axios.get(`${url}/new_order/available_orders_pro` + (education ? education : ''))
        .then(response => {
            return {
                countNewOrdersPro: response.data,
            };
        });
}

function countPersonalOrders() {
    return axios.get(`${url}/new_order/personal_orders`)
        .then(response => {
            return {
                countPersonalOrders: response.data.count,
            };
        });
}

function ordersStatSenior() {
    return axios.get(`${url}/users/orders-stat-senior`)
        .then(response => {
            return {
                ordersStatSenior: response.data,
            };
        });
}

function writeRejected(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/write_rejected`, payload, options)
        .then(response => {
            return {
                writeRejected: response.data
            };
        });
}

function getActionBlockSelects() {
    return axios.get(`${url}/new_order/last_for_retoucher`)
        .then(response => {
            return {
                actionBlockSelects: response.data
            };
        });
}

function getViewOrder(order_id, archive) {
    let needleUrl = `${url}/order/order_view`;
    if (order_id) {
        needleUrl += '/' + order_id;
    }

    return axios.get(needleUrl, {
        params: { archive }
    })
        .then(response => {
            return {
                viewOrder: response.data,
                meta: response.data.meta
            };
        });
}

function setViewOrder(params) {
    return axios.post(`${url}/order/order_view/` + params + '/put')
        .then(response => {
            return {
                result: response.data
            };
        });
}

function setViewOrderSigned(params) {
    return axios.post(`${url}/order/view/` + params.order_number + '?signature=' + params.order_signature)
        .then(response => {
            return {
                result: response.data
            };
        }).catch(error => {
            return {
                result: undefined
            };
        });
}

// function checkDownloadFile(orderId) {
//     return axios.get(`${url}/check_retoucher_download_file/` + orderId)
//         .then(response => {
//             return {
//                 checkDownloadFile: response.data
//             };
//         });
// }

function logDownloadFile(payload) {
    return axios.post(`${url}/log_download_file`, payload)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function addFaceToOrder(payload) {
    return axios.post(`${url}/new_order/photo/meta/faces/add`, payload)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function deleteFaceFromOrder(payload) {
    return axios.post(`${url}/new_order/photo/meta/faces/delete`, payload)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

function restoreFaceFromOrder(payload) {
    return axios.post(`${url}/new_order/photo/meta/faces/restore`, payload)
        .then(response => {
            return {
                functions: response.data
            };
        });
}

export default {
    mainPhotoBlock,
    mainPhotoBlockForRetoucher,
    historyBlock,
    prevOrdersBlock,
    prevOrdersBlockById,
    infoBlock,
    financeBlockForRetoucher,
    downtime,
    downtimeRetoucher,
    downtimeFuncBased,
    downtimeRetoucherFuncBased,
    downtimeRetoucherIdleTime,
    dailyChatVersionRetoucherRatings,
    downtimeProRetoucher,
    downtimeSeniorRetoucher,
    downloadExample,
    getNewOrder,
    setToIdleTime,
    submitOrder,
    submitComments,
    submitProblem,
    submitFile,
    whichRetoucher,
    whichRetouchersRejectedToAnotherList,
    writeRejected,
    downtimeForTestRetoucher,
    getActionBlockSelects,
    downloadFromBackFile,
    orderFunctionsBlock,
    orderFunctionsClientFile,
    countNewOrders,
    countNewOrdersPro,
    countPersonalOrders,
    ordersStatSenior,
    getViewOrder,
    setViewOrder,
    setViewOrderSigned,
    addFunctionToOrder,
    deleteFunctionToOrder,
    restoreFunctionToOrder,
    lastRetouchers,
    adminComments,
    //checkDownloadFile,
    logDownloadFile,
    addFaceToOrder,
    deleteFaceFromOrder,
    restoreFaceFromOrder,
};